<template>
  <section
    id="contact"
    class="bg-neutral-50 text-neutral-900 border-t border-neutral-200"
  >
    <div class="mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
      <div class="grid gap-8 lg:grid-cols-[1.1fr_0.9fr] lg:items-center">
        <div class="space-y-5">
          <p class="text-xs font-semibold uppercase tracking-[0.1em] text-neutral-500">
            Contact Route
          </p>
          <h2 class="text-3xl sm:text-4xl font-bold tracking-tight">
            Bring your highest-value quality workflow and the constraints around it.
          </h2>
          <p class="text-lg text-neutral-700">
            We will map it to a governed delivery path, identify the control and validation considerations, and make the next conversation practical instead of speculative.
          </p>
          <div class="flex flex-wrap gap-3">
            <UButton
              to="/contact/"
              size="xl"
              class="!bg-spruce-700 hover:!bg-spruce-600 !text-white"
            >
              Start a Scoped Discussion
            </UButton>
            <UButton
              to="/blog"
              size="xl"
              variant="outline"
              class="!text-neutral-800 !border-neutral-300 hover:!bg-neutral-100"
            >
              Read the Operating Model
            </UButton>
          </div>
          <p class="text-sm text-neutral-600">
            QxAIOPS keeps delivery credible after the first discussion.
          </p>
          <p class="text-sm text-neutral-600">
            If you already know the process area you want to improve,
            <NuxtLink
              to="/product"
              class="underline underline-offset-4 text-spruce-700 hover:text-spruce-600"
            >
              explore quality applications
            </NuxtLink>
            first.
          </p>
        </div>

        <UCard
          class="bg-white text-neutral-900 border border-neutral-200 shadow-sm"
          :ui="{ body: { base: 'space-y-3' } }"
        >
          <template #header>
            <h3 class="text-xl font-semibold text-neutral-900">
              What to Bring
            </h3>
          </template>
          <p class="text-neutral-600 text-sm">
            Share the workflow you want to improve, the control concerns you need to manage, and any regulatory or validation constraints already in view. We will respond with a clear next step.
          </p>
          <UButton
            to="/contact/"
            color="primary"
            size="lg"
            class="w-full justify-center !bg-spruce-700 hover:!bg-spruce-600 !text-white"
          >
            Open the Contact Form
          </UButton>
        </UCard>
      </div>
    </div>
  </section>
</template>
